<script setup lang="ts">
    import { useMediaQuery } from '@vueuse/core';

    const isDesktop = useMediaQuery('(min-width: 1024px)', { ssrWidth: 1024 });
</script>

<template>
    <slot
        v-if="isDesktop"
        name="desktop"
    />
    <slot
        v-else
        name="mobile"
    />
</template>
